import { WebReportEvent, JsErrorReport } from '@slardar/sdk-web';
import BasePlugin from './base-plugin';

/*
 / without stack info Or other useful info, not report
*/
export default class ErrorMissNamePlugin extends BasePlugin {
  handle(event: JsErrorReport) {
    const { payload } = event;
    const { error } = payload;
    // modify js_error level to info
    payload.extra = {
      ...payload.extra,
      level: 'info',
    };
    const msgArr = (error.message || '').split('Error:');
    if (msgArr.length === 2) {
      error.name = `${msgArr[0]}Error`;
      error.message = msgArr[1].trim();
      if (this.next) {
        return this.next.handleErrorEvent(event);
      }
    }
    // modify error name
    error.name = `[info][ErrorMissName] - Missing name of this error`;
    return event;
  }

  shouldHandle(event: WebReportEvent): event is JsErrorReport {
    return event.ev_type === 'js_error' && !event.payload.error?.name;
  }
}
